console.log(`
\ _   _      _ _         _____ _
| | | | ___| | | ___   |_   _| |__   ___ _ __ ___
| |_| |/ _ \\ | |/ _ \\    | | | '_ \\ / _ \\ '__/ _ \\
|  _  |  __/ | | (_) |   | | | | | |  __/ | |  __/
|_| |_|\\___|_|_|\\___/    |_| |_| |_|\\___|_|  \\___|
`);

/* +-----------------------------------------+
|           GLOBALS AREA             		 |
+-----------------------------------------+ */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

import "@iconify/iconify";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

// Fix for ScrollTrigger pinned sections on reload
if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
}


window.DEBUG = false;
window.MNK = !ScrollTrigger.isTouch;
window.TOUCH = !!ScrollTrigger.isTouch; 

/* +-----------------------------------------+
|           IMPORTS AREA             		 |
+-----------------------------------------+ */

// Swiper
import initSwipers from "./swiper/initSwipers";

// CSS
import "../styles/bootstrap/bootstrap.scss";
import "../styles/frontend.scss";

// GSAP
import initGsap from "./gsap/initGsap";
import initGsapTriggers from "./gsap/utilities/initGsapTriggers";
import gsapScrollTo from "./gsap/utilities/gsapScrollTo";

// Bootstrap
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/tab";

// Utilities
import initLoader from "./utilities/initLoader";
import getDimensions from "./utilities/getDimensions";
import initMouseFollower from "./utilities/initMouseFollower";
import initGlightbox from "./utilities/initGlightbox";
import initReadSmore from "./utilities/initReadSmore";
import kobleQuickView from "./utilities/kobleQuickView";
import kobleAutocomplete from "./utilities/kobleAutocomplete";
import kobleAdditionalInfo from "./utilities/kobleAdditionalInfo";
import initMaps from "./utilities/initMaps";
import appendToBody from "./utilities/appendToBody";
// import togglePairedCheckboxes from "./utilities/togglePairedCheckboxes";
import initToastify from "./utilities/initToastify";
import initShare from "./utilities/initShare";
import currencySwitcher from "./utilities/currencySwitcher";
import initCleave from "./utilities/initCleave";
import openModalByUrl from "./utilities/openModalByUrl";
import initDrawer from "./utilities/initDrawer";
import initSearchDrawer from "./utilities/initSearchDrawer";
import initOffcanvasSwipe from "./utilities/initOffcanvasSwipe";
import initLazyVideo from "./utilities/initLazyVideo";
import getStickyElements from "./utilities/getStickyElements";
import initBlogAjax from "./utilities/initBlogAjax";

/* +-----------------------------------------+
|           EVENTS AREA             		 |
+-----------------------------------------+ */

// DOC Ready
document.addEventListener(
    "DOMContentLoaded",
    () => {

        getDimensions("#app-header", "height");
        getDimensions("#app-topbar", "height");
        getDimensions("#app-navbar", "height");

        initReadSmore();
        // initMouseFollower();
        initSwipers();
        initGlightbox();
        kobleQuickView();
        kobleAutocomplete();
        kobleAdditionalInfo();
        initMaps();
        // togglePairedCheckboxes();
        initToastify();
        initShare();
        currencySwitcher();
        initCleave();
        openModalByUrl();
        initDrawer();
        initSearchDrawer();
        initOffcanvasSwipe();
        initBlogAjax();

    },
    { once: true }
);

// WINDOW Ready
window.addEventListener(
    "load",
    () => {
        
        initGsap();
        initGsapTriggers();
        
        getStickyElements();
        appendToBody(".modal");
        appendToBody(".offcanvas");
        initLoader();
        initLazyVideo();

        const hash = window.location.hash;
        if (hash) gsapScrollTo(hash);
    },
    { once: true }
);

// WS Form
(function ($) {
    $(document).on("wsf-rendered", () => {
        getDimensions(".iti__flag-container", "width");
        getDimensions("input.wsf-field", "height");
    });

    $(document).on(
        "wsf-validate-after",
        function (
            event,
            form_object,
            form_id,
            instance_id,
            form_el,
            form_canvas_el
        ) {
            const transitionSpeed = parseFloat(
                getComputedStyle(form_el[0])
                    .getPropertyValue("--wsf-form-transition-speed")
                    .replace("ms", "")
                    .trim()
            );

            setTimeout(getStickyElements, transitionSpeed); 
        }
    );
})(jQuery);